import { CustomDialog } from 'Components/CustomDialog';
import { useState } from 'react';

export const useCustomDialog = () => {
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [dialogContent, setDialogContent] = useState<React.ReactNode | null>(
    null
  );

  const setHideDialog = () => {
    setDialogContent(null);
    setShowDialog(false);
  };

  const onShowDialog = (dialogContent: React.ReactNode) => {
    setDialogContent(dialogContent);
    setShowDialog(true);
  };

  const dialog = (
    <CustomDialog showDialog={showDialog} onclose={setHideDialog}>
      {dialogContent}
    </CustomDialog>
  );

  return {
    setShowDialog: onShowDialog,
    setHideDialog,
    dialog,
  };
};
